import Close from "@mui/icons-material/Close";
import { Badge, Box, IconButton } from "@mui/material";
import type { FC } from "react";

interface ReferenceImageThumbnailProps {
  url: string;
  onRemove: (url: string) => void;
}

export const ReferenceImageThumbnail: FC<ReferenceImageThumbnailProps> = ({ url, onRemove }) => {
  return (
    <Badge
      badgeContent={
        <IconButton
          data-analytics-id="ai-tab-remove-reference-image"
          size="small"
          onClick={() => onRemove(url)}
          sx={{
            p: 0,
            width: 16,
            height: 16,
            backgroundColor: "grey.700",
            color: "white",
            "&:hover": {
              backgroundColor: "grey.900",
            },
          }}
        >
          <Close sx={{ fontSize: 12 }} />
        </IconButton>
      }
      sx={{
        "& .MuiBadge-badge": {
          p: 0,
          minWidth: 16,
          height: 16,
          top: 2,
          right: 2,
        },
      }}
    >
      <Box
        component="img"
        src={url}
        alt="Reference"
        sx={{
          width: 40,
          height: 40,
          objectFit: "cover",
          borderRadius: 1,
          border: 1,
          borderColor: "divider",
        }}
      />
    </Badge>
  );
};
